import React from 'react'
import classNames from 'classnames'
import { LabelSM } from '@/atoms/Text'

interface WatchHeroPillsProps {
  themes: string[]
  className?: string
}

export const WatchHeroPills: React.FC<WatchHeroPillsProps> = ({ themes, className }) => {
  if (themes.length === 0) return null

  return (
    <div className={classNames('mb-4 flex flex-wrap items-center justify-center gap-3 md:justify-start', className)}>
      {themes.map((theme) => (
        <span
          key={theme}
          className="rounded-xl border border-transparent bg-core-gray-800 px-3 py-1.5 backdrop-blur-xl"
        >
          <LabelSM color="core-gray-200">{theme}</LabelSM>
        </span>
      ))}
    </div>
  )
}
